import request from '../api/request'

// 添加抽取试卷信息
export function rollExamPaper(data) {
    return request({
      url: '/rollExamPaper/add',
      method: 'post',
      data: data
    })
}

// 分页查询试卷信息
export function queryExamPapers(param) {
    return request({
      url: '/rollExamPaper/queryExamPapers',
      method: 'get',
      params: param
    })
}

// 批量删除试卷
export function deleteExamPaper(param) {
    return request({
        url: '/rollExamPaper/deleteByIds',
        method: 'delete',
        params:param
    })
}

// 删除服务器文件
export function deleteUplaodFile(param) {
    return request({
        url: '/transfer/delete',
        method: 'delete',
        params:param
    })
}

// 根据科目查询考试名称
export function queryRollExamNamesBySubjectId(subjectId) {
    return request({
      url: '/rollExamPaper/queryRollExamNamesBySubjectId/'+subjectId,
      method: 'get',
    })
}

// 根据科目和考试查询抽提试卷
export function queryRollExamPapers(param) {
    return request({
      url: '/rollExamPaper/queryExamPaperBySubjectAndExamName',
      method: 'get',
      params:param
    })
}

// 记录本次抽取
export function recordRollExamPaper(data) {
    return request({
      url: '/rollExamPaper/recordRollExamPaper',
      method: 'post',
      data: data
    })
}

// 分页查询抽取记录
export function queryRollRecords(param) {
    return request({
      url: '/rollExamPaper/queryRollExamPaperHistory',
      method: 'get',
      params: param
    })
}